import React, { useState } from 'react';
import { useIntl } from '../../../util/reactIntl';

import css from './Sections.module.css';
import Icons from '../../../components/Icons/Icons';
import classNames from 'classnames';

function HowItWorks({ useHistoryPush }) {
  const intl = useIntl();
  const [activeTab, setActiveTab] = useState('customer');

  const customerSections = [
    {
      icon: 'featureIcon1',
      title: intl.formatMessage({ id: 'HowItWorks.customer.step1.title' }),
      description: intl.formatMessage({ id: 'HowItWorks.customer.step1.description' }),
    },
    {
      icon: 'featureIcon2',
      title: intl.formatMessage({ id: 'HowItWorks.customer.step2.title' }),
      description: intl.formatMessage({ id: 'HowItWorks.customer.step2.description' }),
    },
    {
      icon: 'featureIcon3',
      title: intl.formatMessage({ id: 'HowItWorks.customer.step3.title' }),
      description: intl.formatMessage({ id: 'HowItWorks.customer.step3.description' }),
    },
  ];

  const providerSections = [
    {
      icon: 'featureIcon1',
      title: intl.formatMessage({ id: 'HowItWorks.provider.step1.title' }),
      description: intl.formatMessage({ id: 'HowItWorks.provider.step1.description' }),
    },
    {
      icon: 'featureIcon2',
      title: intl.formatMessage({ id: 'HowItWorks.provider.step2.title' }),
      description: intl.formatMessage({ id: 'HowItWorks.provider.step2.description' }),
    },
    {
      icon: 'featureIcon3',
      title: intl.formatMessage({ id: 'HowItWorks.provider.step3.title' }),
      description: intl.formatMessage({ id: 'HowItWorks.provider.step3.description' }),
    },
  ];

  const sections = activeTab === 'customer' ? customerSections : providerSections;

  return (
    <div className={css.howItWorkSection}>
      <div className={css.fixedWidthContainer}>
        <div className={css.sectionHead}>
          <div className={css.leftSec}>
            {/* <span>{intl.formatMessage({ id: 'HowItWorks.kicker' })}</span> */}
            <h2>{intl.formatMessage({ id: 'HowItWorks.title' })}</h2>
            <p>{intl.formatMessage({ id: 'HowItWorks.subtitle' })}</p>
          </div>

          <div className={css.tabs}>
            <span
              className={classNames(css.tab, { [css.active]: activeTab === 'customer' })}
              onClick={() => setActiveTab('customer')}
            >
              {intl.formatMessage({ id: 'HowItWorks.tabs.customer' })}
            </span>
            <span
              className={classNames(css.tab, { [css.active]: activeTab === 'provider' })}
              onClick={() => setActiveTab('provider')}
            >
              {intl.formatMessage({ id: 'HowItWorks.tabs.provider' })}
            </span>
          </div>
        </div>

        <div className={css.moreInfoSec}>
          {sections.map((section, index) => (
            <div className={css.moreInfoBlock} key={index}>
              <Icons name={section.icon} />
              <h4>{section.title}</h4>
              <p>{section.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HowItWorks;
